export const dotNetPageData = {
  hero: {
    heading: "Dot Net Development Services",
    subtext:
      "Quokka Labs delivers dot net development services for teams building new products or modernizing .NET legacy stacks. As a net development company, we engineer secure APIs, scalable cloud-ready architectures, and integration-first workflows. Our net software development services emphasize maintainability, governance, and performance, so your platform evolves faster without fragile rewrites today.",
    buttonText: "Talk to an Expert",
    link: "https://quokkalabs.com/contact-us",
  },

  awardsSection: {
    title: "Award-Winning Dot Net Development Company",
  },

  services: {
    heading: "Our Dot Net Development Services Offerings",
    intro:
      "We deliver net application development services to build, modernize, and scale secure .NET platforms. As a net software development company, we focus on clean architecture, reliable APIs, and integration-ready delivery—so your product ships faster and stays maintainable.",

    items: [
      {
        title: "Enterprise Dot NET Development",
        desc: "We engineer enterprise-grade .NET platforms with clear domain models, scalable service layers, governance-ready security, and production observability—ideal for high-traffic systems, internal platforms, and mission-critical workflows. Expect patterns like DDD, background processing, and resilient messaging when needed.",
      },
      {
        title: "Dot NET Web App Development",
        desc: "As a dot net application development company, we deliver full-featured web platforms using ASP.NET Core, minimal APIs, and modern MVC patterns—covering backend architecture, API layers, authentication, and enterprise-grade reliability.",
      },
      {
        title: "Dot NET Desktop Application Development",
        desc: "We build Windows desktop applications for specialized workflows—operations tooling, regulated environments, and internal productivity suites—designed for stability, secure data handling, and long-term support.",
      },
      {
        title: "Dot Net CMS Development",
        desc: "We develop CMS-driven platforms on .NET that make content updates simple without sacrificing performance—ideal for multi-page websites, portals, and content-heavy products with role-based publishing and workflow approvals.",
      },
      {
        title: "Dot Net Ecommerce Solutions",
        desc: "We build .NET-based ecommerce experiences with secure checkout, catalog and inventory flows, promotions, and order management—optimized for speed, integrations, and conversion-ready user journeys.",
      },
      {
        title: "Dot Net Integration",
        desc: "We connect your .NET applications with CRMs, ERPs, payment gateways, analytics tools, identity providers, and legacy systems—using secure APIs, event-driven workflows, and integration patterns that keep data reliable.",
      },
      {
        title: "Dot Net ERP Solutions",
        desc: "We build custom ERP systems and ERP extensions on .NET to unify finance, procurement, inventory, operations, and reporting—designed for role-based access, auditability, and scalable workflows.",
      },
      {
        title: "Dot Net Cloud based Solutions",
        desc: "We design cloud-ready .NET architectures for Azure or hybrid environments—containerized services, autoscaling, CI/CD pipelines, observability, and cost-optimized infrastructure built for uptime and growth.",
      },
      {
        title: "Dot NET Modernization & Migration",
        desc: "We run modernization initiatives end-to-end, upgrading to current .NET LTS versions, moving from .NET Framework to .NET, refactoring monoliths into modular services, and shifting workloads to cloud-native runtimes with minimal disruption. We also containerize services, replace brittle Windows-only dependencies, and move workloads to Linux.",
      },
    ],
  },

  trutStats: {
    heading: "Dot Net Development Expertise Proven by Real-World Results",
    items: [
      {
        value: "12+",
        label: "Years of Experience",
      },
      {
        value: "200+",
        label: "Projects Delivered",
      },
      {
        value: "60+",
        label: "Digital products designed and developed",
      },
      {
        value: "40%",
        label: "Faster delivery using AI engineering accelerators",
      },
    ],
  },

  mainServices: {
    heading: "Our Services",
    intro:
      "Our services combine scalable engineering, automation-ready architecture, and performance-focused delivery to build dependable digital products. We help teams launch secure, growth-ready applications that support complex workflows, data platforms, integrations, analytics, and operational automation across modern business environments.",

    categories: [
      {
        title: "AI Development Services",
        items: [
          {
            title: "AI Consulting",
            desc: "We help teams identify high-value AI use cases across automation, decision support, forecasting, and product experience—aligning initiatives with measurable outcomes and sustainable scale.",
            link: "./ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-phone.svg",
          },
          {
            title: "Generative AI Consulting",
            desc: "We evaluate where generative AI can deliver practical impact—documentation, internal knowledge search, customer support tooling, and reporting—then define a safe path from pilot to production.",
            link: "./generative-ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-image.svg",
          },
          {
            title: "Agentic AI Development",
            desc: "We build agentic systems that execute multi-step workflows like routing, approvals, escalations, and data processing—integrating securely with your apps and tools.",
            link: "./agentic-ai-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-programming.svg",
          },
          {
            title: "AI Native Development",
            desc: "We design AI-native products where intelligence powers core workflows—prediction layers, personalization, recommendations, and decisioning inside the primary user experience.",
            link: "./ai-native-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-voice.svg",
          },
          {
            title: "AI Security",
            desc: "We secure AI systems with monitoring, governance frameworks, policy controls, and protected data pipelines suited for regulated or high-scale environments.",
            link: "./ai-security-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-security.svg",
          },
          {
            title: "Generative AI Development",
            desc: "We develop LLM-powered solutions for automated insights, content generation, reporting assistants, internal chat tools, and operational support modules.",
            link: "./generative-ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-computer.svg",
          },
          {
            title: "AI Development",
            desc: "We deliver end-to-end AI feature development—from model strategy to API integration and UI implementation—focused on performance, reliability, and real-world usability.",
            link: "./ai-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-innovation.svg",
          },
          {
            title: "ML Development",
            desc: "We build and deploy machine learning models for forecasting, anomaly detection, optimization, and behavioral analysis to improve decisions and operations.",
            link: "./ml-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-setting.svg",
          },
          {
            title: "AI/ML Development",
            desc: "We combine AI and ML to create systems that balance speed, automation, reliability, and transparency across real-time and batch workloads.",
            link: "./artificial-intelligence-machine-learning-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-brain.svg",
          },
        ],
      },

      {
        title: "App Development Services",
        items: [
          {
            title: "Mobile Application Development",
            desc: "We build secure, high-performance mobile apps that connect seamlessly with backend systems—supporting workflow access, reporting, and collaboration across devices.",
            link: "./mobile-app-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame.svg",
          },
          {
            title: "Web Application Development",
            desc: "We design and modernize web applications with scalable architecture, secure APIs, and modular systems that support growing users and evolving requirements.",
            link: "./web-application-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/web-design.svg",
          },
          {
            title: "Data and Analytics",
            desc: "We turn data into actionable dashboards, predictive models, and performance insights that enable faster, evidence-based decisions.",
            link: "./data-analytics-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/data-recovery.svg",
          },
          {
            title: "Blockchain Development",
            desc: "We build blockchain-enabled systems for secure record-keeping, identity verification, audit trails, and multi-party validation where transparency matters.",
            link: "./blockchain-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame2.svg",
          },
          {
            title: "iOS Application Development",
            desc: "We develop iOS applications optimized for performance and stability, with secure integrations and synchronized data flows.",
            link: "./ios-app-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Fra3.svg",
          },
          {
            title: "UI/UX Design",
            desc: "We design clear, intuitive interfaces focused on usability, accessibility, and smooth interaction across complex products.",
            link: "./ui-ux-design-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Fram4.svg",
          },
          {
            title: "DevOps Services",
            desc: "We implement DevOps practices that automate deployments, support infrastructure scaling, improve monitoring, and maintain high availability.",
            link: "./devops-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/wireless-cloud.svg",
          },
          {
            title: "Quality Assurance Engineering",
            desc: "We test applications for reliability, integration accuracy, security vulnerabilities, and load handling to ensure stable production performance.",
            link: "./quality-analyst",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/phone-check.svg",
          },
          {
            title: "AR and VR",
            desc: "We build AR/VR applications for training, simulations, visualization, and interactive experiences that improve understanding and productivity.",
            link: "./ar-vr-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/vr-stroke-rounded.svg",
          },
        ],
      },

      {
        title: "Staff Augmentation",
        items: [
          {
            title: "Android Developers",
            desc: "Add Android engineers to build secure apps integrated with modern backend systems and distributed infrastructure.",
            link: "./hire-android-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-programming.svg",
          },
          {
            title: "iOS Developers",
            desc: "Scale delivery with iOS specialists who ship stable applications aligned with quality and security standards.",
            link: "./hire-ios-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/appstore.svg",
          },
          {
            title: "Flutter Developers",
            desc: "Accelerate cross-platform delivery with Flutter engineers using maintainable shared codebases.",
            link: "./hire-flutter-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/phone-developer.svg",
          },
          {
            title: "React Native Developers",
            desc: "Expand your roadmap with React Native engineers who build consistent experiences while reducing maintenance overhead.",
            link: "./hire-react-native-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/react-stroke.svg",
          },
          {
            title: "Python Developers",
            desc: "Leverage Python developers for backend services, automation workflows, analytics systems, and AI integrations.",
            link: "./hire-python-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/python.svg",
          },
          {
            title: ".NET Developers",
            desc: "Work with .NET engineers to build secure systems with strong integration capability and long-term maintainability.",
            link: "./hire-dotnet-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/server-stack.svg",
          },
          {
            title: "Node.js Developers",
            desc: "Scale real-time features with Node.js developers building event-driven services for high-concurrency workloads.",
            link: "./hire-node-js-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/3rd-bracket.svg",
          },
          {
            title: "React JS Developers",
            desc: "Strengthen frontend execution with React developers building modular, high-performance interfaces connected to APIs.",
            link: "./hire-react-js-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-programming.svg",
          },
          {
            title: "Firebase Developers",
            desc: "Hire Firebase experts to implement real-time features, authentication, cloud storage, and analytics tracking.",
            link: "./hire-firebase-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/fire-stroke.svg",
          },
        ],
      },
    ],
  },

  newsLetter: {
    heading: "Ready to Modernize and Scale Your .NET Platform with Confidence?",
    desc: "From internal systems and SaaS products to complex workflow engines and data-driven dashboards, we help organizations launch secure, high-performance .NET solutions engineered for stability, scalability, and long-term operational success.",
    buttonText: "Get Started",
    link: "https://quokkalabs.com/contact-us",
  },

  caseStudies: {
    heading: "Dot Net Development Services that Turn Roadmaps into Results",

    items: [
      {
        title: "SHL",
        desc: "SHL is a mobile-enabled enterprise platform built to support large-scale talent assessments, analytics, and workforce insights. It manages complex workflows, multi-role access, and high data volumes, while staying stable for global users. We helped deliver a product experience that performs under real operational load.",
        results: [
          "50% Increase in Assessment Throughput",
          "30% Improvement in Platform Adoption",
        ],
        url: "./shl",
        color: "#DDEEFF",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/shl-newww.webp",
      },
      {
        title: "Talent Quest",
        desc: "Talent Quest is a short-form talent video-sharing platform built to help users showcase skills, discover creators, and engage through video-first interactions. Quokka Labs delivered a scalable platform foundation focused on performance, seamless media workflows, and smooth user experiences across high-engagement environments.",
        results: [
          "80% Faster Talent Discovery and Content Engagement",
          "90% More Improved Creator Experience",
        ],
        url: "./talentquest",
        color: "#F8DCFF",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/talent-quest-new.webp",
      },
      {
        title: "MNRE Street Light",
        desc: "MNRE Street Light is a solar street light implementation and tracking platform designed to manage approvals, deployment progress, and field-level visibility across large public infrastructure programs. Quokka Labs helped build a structured, workflow-driven system that improves monitoring, transparency, and execution across distributed operations.",
        results: [
          "90% Improved Tracking of Installation",
          "80% Better Operational Visibility",
        ],
        url: "./mnre",
        color: "#C9DCFF",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mnre-new.webp",
      },
      {
        title: "Biogas India",
        desc: "Biogas India is a biogas plant installation and management platform built to streamline project coordination, deployment tracking, and operational oversight. Quokka Labs delivered a digital solution that supports structured workflows, status visibility, and efficient management across installation and maintenance lifecycles.",
        results: [
          "90% More Efficient Plant Installation",
          "50% Stronger Visibility",
        ],
        url: "./biogas",
        color: "#C9FFC9",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/biogas-new.webp",
      },
      {
        title: "StarFarm",
        desc: "StarFarm is a music streaming and artist platform built to connect creators with listeners through a digital-first entertainment experience. Quokka Labs helped shape a scalable platform that supports artist discovery, content access, and smooth streaming interactions across modern user journeys.",
        results: [
          "50% More Improved Artist Visibility",
          "30% More Smoother Content Access",
        ],
        url: "./starfarm",
        color: "#B2FFEF",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/starfarm_new.webp",
      },
      {
        title: "Swift Digital",
        desc: "Swift Digital is a comprehensive event management platform designed to streamline event planning, attendee coordination, and on-ground execution. Quokka Labs delivered a structured digital experience that supports registrations, scheduling, engagement workflows, and event operations from one centralized system.",
        results: [
          "80% More Improved Event Management",
          "90% Better Coordination for Organizers and Attendees",
        ],
        url: "./swift-digital",
        color: "#BCE0FF",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/swift-digital-new.webp",
      },
      {
        title: "Smogwise",
        desc: "Smogwise is a vehicle emission testing and reporting service built to support inspection workflows, reporting accuracy, and compliance visibility. Quokka Labs helped deliver a system that improves operational tracking, digitizes reporting, and supports smoother management of testing and emission-related records.",
        results: [
          "90% Improved Efficiency in Emission Testing Workflows",
          "80% Better Reporting Visibility",
        ],
        url: "./smogwise",
        color: "#FFDCC5",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/smogwise-new.webp",
      },
    ],
  },

  keyFeatures: {
    heading: "Key Features We Integrate into .NET Applications",

    items: [
      {
        title: "Scalable Multi-Tenant .NET Architecture",
        desc: "Enterprise .NET platforms often serve multiple regions, brands, or customer accounts—without compromising security or performance. We build multi-tenant .NET systems that isolate data, enforce access controls, and scale smoothly as usage grows.",
        points: [
          "Tenant-aware schemas with strong data separation",
          "RBAC/ABAC permission layers with policy-based authorization",
          "Stateless API patterns for horizontal scaling",
          "High-availability design with redundancy and failover readiness",
          "Tenant-specific configuration, feature flags, and admin controls",
          "Central governance with localized tenant policies",
        ],
      },
      {
        title: "Event-Driven Workflows & Real-Time Processing",
        desc: "Modern operations rely on fast, traceable execution. We implement event-driven workflows and real-time pipelines in .NET so processes run reliably, exceptions are handled cleanly, and teams get immediate visibility.",
        points: [
          "Message queues and event streaming for real-time flows",
          "Workflow orchestration for approvals, routing, and automation",
          "Live operational dashboards with system metrics",
          "Reliable background jobs for high-volume async processing",
          "Alerts, notifications, and escalation triggers",
          "Embedded analytics for performance and decision visibility",
        ],
      },
      {
        title: "Secure API-First Integrations for Microsoft Ecosystems",
        desc: ".NET applications deliver more value when they integrate cleanly with the systems around them. We build API-first .NET platforms that connect with CRMs, ERPs, identity providers, partner tools, and legacy services—while keeping security and governance tight.",
        points: [
          "REST/GraphQL APIs aligned with OpenAPI standards",
          "OAuth2/SSO/JWT authentication with identity federation",
          "API gateway patterns for throttling, monitoring, and auditing",
          "ERP/CRM connectors and integration adapters",
          "Secure webhooks, event triggers, and integration pipelines",
          "Partner onboarding frameworks with access policies and limits",
        ],
      },
      {
        title: "Rules Engines, Automation & Compliance-Ready Execution",
        desc: "Enterprise systems need consistent decisions, traceable actions, and audit-ready workflows. We implement rules and automation layers in .NET that reduce manual effort and adapt to change without rewriting core services.",
        points: [
          "Configurable business rules and policy-driven workflows",
          "Approval chains, exception handling, and escalation logic",
          "Automated reporting, verification routines, and audit outputs",
          "Scheduled jobs, batch processing, and orchestration",
          "Intelligent task routing based on role, priority, and conditions",
          "Immutable audit trails and event logs for compliance needs",
        ],
      },
    ],
  },

  capabilities: {
    heading: "What You Get with Our Dot Net Development Services Expertise",
    subtext:
      "Our .NET delivery is built for real production demands—secure foundations, predictable releases, and systems that stay maintainable as requirements change. Every engagement balances speed with reliability, cloud readiness with governance, and flexibility with performance—so your platform scales without fragile workarounds or repeated rebuilds.",

    items: [
      {
        title: "Modern .NET Architecture That Stays Clean",
        desc: "We design solutions using .NET best practices—layered architecture, domain-driven boundaries where needed, and modular components that keep teams moving fast without turning the codebase into a maze.",
      },
      {
        title: "Cloud-Ready Builds (Azure + Hybrid Friendly)",
        desc: "We engineer cloud-based solutions that deploy confidently across Azure, hybrid, or containerized environments—supporting autoscaling, environment parity, and cost-aware infrastructure decisions.",
      },
      {
        title: "Performance & Scalability Engineering for .NET",
        desc: "We optimize throughput and latency with profiling, caching layers, async patterns, database tuning, and smart background processing—so APIs and workflows stay responsive under real traffic.",
      },
      {
        title: "Secure Identity, Access & Compliance Controls",
        desc: "We implement enterprise-grade security—SSO/OAuth2, JWT, RBAC/ABAC, encryption, secrets management, and audit logs—so your platform is built for regulated workflows and sensitive data.",
      },
      {
        title: "Integration That Doesn't Break in Production",
        desc: "We build integration-first systems that connect reliably with CRMs, ERPs, payment gateways, analytics tools, and legacy services—using robust APIs, event-driven patterns, and validation layers to keep data consistent.",
      },
      {
        title: "Release Discipline & Long-Term Maintainability",
        desc: "We set up CI/CD pipelines, automated testing, code quality gates, and rollback strategies—so teams release faster with fewer incidents and lower maintenance overhead over time.",
      },
      {
        title: "Monitoring, Observability & Operational Confidence",
        desc: "We add structured logging, metrics, tracing, alerting, and incident-ready dashboards—so teams can detect issues early, debug faster, and protect uptime across complex .NET environments.",
      },
    ],
  },

  ourProcess: {
    heading: "Our End-to-End Delivery Process for Modern Dot NET Platforms",

    subtext:
      "A structured, architecture-first process that turns complex requirements into scalable, secure .NET solutions. From product strategy and UX to .NET architecture, engineering, QA, and release management, our approach keeps delivery predictable while protecting long-term performance, stability, and business value.",

    steps: [
      {
        number: "01",
        title: "Discovery & .NET Product Roadmap",
        desc: "We start by mapping business outcomes, user roles, critical workflows, compliance needs, and the systems your platform must connect with. Then we translate that into clear domain boundaries, integration requirements, and a phased delivery plan that reduces risk and prevents expensive rework later.",
      },
      {
        number: "02",
        title: "UX, Journeys & Workflow Design",
        desc: "We design experiences around speed and clarity—especially for operational and multi-role products. Wireframes and prototypes focus on task completion, dashboard visibility, approvals, and edge cases so the product feels intuitive even when workflows are complex.",
      },
      {
        number: "03",
        title: ".NET Architecture, Data Model & Security Baseline",
        desc: "We define the right .NET architecture—modular monolith, microservices, or hybrid—based on scale, release cadence, and integration complexity. This includes API standards, database choices, caching strategy, identity and access control, observability, and cloud deployment plans (Azure or hybrid) to ensure performance under load without compromising security.",
      },
      {
        number: "04",
        title: "Iterative .NET Development & Integration Sprints",
        desc: "Our teams deliver in structured sprints across backend services, APIs, web/mobile frontends, and integrations. We implement business logic, role-based permissions, background processing, event-driven workflows, and connectors to ERPs/CRMs/third-party tools—shipping usable increments continuously.",
      },
      {
        number: "05",
        title: "Quality, Performance & Production Hardening",
        desc: "We validate beyond 'it works.' Testing covers workflows, data integrity, edge cases, and integration reliability. Performance work includes profiling, load testing, async and concurrency validation, database tuning, and security checks like authentication flows, dependency scanning, and audit logging.",
      },
      {
        number: "06",
        title: "Deployment, CI/CD & Observability Setup",
        desc: "We implement CI/CD pipelines, environment parity, monitoring, structured logging, alerting, and rollback strategies. Release readiness includes deployment automation, secrets management, configuration governance, and runtime visibility—so teams can release confidently and troubleshoot faster.",
      },
      {
        number: "07",
        title: "Post-Launch Optimization & Continuous Evolution",
        desc: "After launch, we improve throughput, reduce latency, expand features safely, and evolve architecture as usage grows. Whether you're modernizing legacy modules or scaling new services, we keep the .NET platform stable and maintainable through continuous refinement.",
      },
    ],
  },

  compliance: {
    heading: "Built to Meet Enterprise-Grade .NET Compliance Standards",

    intro:
      "Compliance is built into every .NET engagement we run - not bolted on after release. Our dot net development services align architecture, security, and delivery practices with privacy requirements, cybersecurity controls, IP protection, and operational governance. Whether you're building internal platforms, customer-facing portals, SaaS products, or multi-tenant .NET applications, we design for audit readiness, data protection, and long-term regulatory stability.",

    sections: [
      {
        title: "Application Security & Threat Protection",
        desc: "We build secure .NET architectures with strong encryption, hardened APIs, secure authentication, automated security testing, and continuous monitoring. From dependency hygiene to runtime safeguards, our delivery reduces risk across development, deployment, and ongoing operations.",
      },
      {
        title: "Data Privacy & Information Governance",
        desc: "Sensitive data is handled with least-privilege access, encryption at rest and in transit, audit trails, and region-aware configuration. We implement governance controls that support transparency, traceability, and modern privacy expectations across distributed environments.",
      },
      {
        title: "Operational Resilience & Risk Management",
        desc: "We engineer .NET platforms to remain stable under real-world stress—structured logging, incident readiness, disaster recovery planning, and high-availability infrastructure. Our delivery includes backup strategies, failover patterns, and reliability practices that protect business continuity during outages, traffic spikes, or security incidents.",
      },
    ],

    standards: [
      "GDPR – Data privacy and protection regulation",
      "CCPA – Consumer data privacy requirements",
      "SOC 2 – Security and operational controls",
      "ISO/IEC 27001 – Information security management",
      "OWASP – Secure application best practices",
      "PCI-DSS – Payment data security requirements",
    ],
  },

  industries: {
    heading:
      "We Enable Enterprise-Grade .NET Transformation Across Key Industries",

    subtext:
      "Our dot net development services support organizations operating in high-scale, high-security, and high-compliance environments. As a net software development company, we build secure, scalable .NET platforms that modernize operations, connect systems, and unlock long-term digital transformation across regulated and growth-driven industries.",

    items: [
      {
        title: "Healthcare",
        image: "",
        points: [
          "Patient portals, scheduling, and care coordination platforms built on secure .NET foundations",
          "EHR/EMR-ready integrations for reporting, interoperability, and operational visibility",
          "Role-based access for clinicians, staff, and administrators with audit trails",
          "Encrypted data handling and compliance-aligned architecture for sensitive health data",
        ],
      },
      {
        title: "Manufacturing",
        image: "",
        points: [
          "Production monitoring and plant coordination systems with real-time operational visibility",
          "Inventory, logistics, and procurement dashboards built for multi-site environments",
          "ERP-integrated workflows for planning, traceability, and execution",
          "Automation layers that reduce manual steps and improve process consistency",
        ],
      },
      {
        title: "Education",
        image: "",
        points: [
          "Scalable .NET web platforms for LMS, learner management, and training operations",
          "Secure portals for admissions, assessments, content delivery, and progress tracking",
          "Multi-role experiences for learners, faculty, and administrators",
          "Analytics dashboards for completion, engagement, and performance reporting",
        ],
      },
      {
        title: "Real Estate",
        image: "",
        points: [
          "Platforms for property management, transactions, and portfolio workflows",
          "CRM-integrated systems for brokers, agencies, and customer coordination",
          "Secure document workflows with e-signatures, versioning, and permissions",
          "High-performance portals for listings, tenant operations, and deal pipelines",
        ],
      },
      {
        title: "FinTech",
        image: "",
        points: [
          "Secure .NET applications for payments, lending, and financial workflows",
          "Compliance-ready architecture with audit logs, monitoring, and risk controls",
          "High-availability systems designed for transaction-heavy uptime requirements",
          "API-first integrations with banking partners, identity providers, and fintech services",
        ],
      },
      {
        title: "Retail",
        image: "",
        points: [
          "Omnichannel commerce and operations platforms built for speed and reliability",
          "Inventory, order, returns, and fulfillment workflows with real-time accuracy",
          "Loyalty, personalization, and customer portals integrated with CRM and analytics",
          "Performance-optimized systems designed for peak traffic and seasonal spikes",
        ],
      },
    ],
  },

  // techStack: {
  //   heading: "Our Tech Stack",

  //   intro:
  //     "We use a modern, production-ready tech stack engineered to support secure, scalable, and high-performance .NET application development services.",

  //   categories: [
  //     {
  //       title: "Frontend",
  //       items: ["HTML5", "CSS3", "Tailwind CSS", "JavaScript", "React.js"],
  //     },
  //     {
  //       title: "Mobile",
  //       items: ["iOS (Swift)", "Android (Kotlin)", "Flutter", "React Native"],
  //     },
  //     {
  //       title: "Backend",
  //       items: [".NET", "ASP.NET Core", "C#", "Node.js", "Python"],
  //     },
  //     {
  //       title: "Database",
  //       items: ["SQL Server", "PostgreSQL", "MongoDB", "Azure SQL"],
  //     },
  //     {
  //       title: "Cloud & DevOps",
  //       items: ["Azure", "AWS", "Docker", "Kubernetes", "CI/CD Pipelines"],
  //     },
  //     {
  //       title: "AI & Analytics",
  //       items: [
  //         "Machine Learning",
  //         "Generative AI",
  //         "Data Analytics",
  //         "TensorFlow",
  //       ],
  //     },
  //   ],
  // },

  newsLetter2: {
    heading:
      "Reduce Infrastructure Spend by Up to 40% with Optimized .NET Architecture",

    subtext:
      "From ASP.NET Core APIs to enterprise platforms, our dot net development services help you modernize cloud, data, and backend layers for efficiency—delivering faster performance, smoother scaling, and lower long-term operating costs.",

    buttonText: "Book a Call",
    link: "https://quokkalabs.com/contact-us",
  },

  ai_Focused: {
    heading: "AI-Powered Capabilities for Modern Dot NET Platforms",

    subtext:
      "We bring AI, machine learning, and real-time analytics into .NET applications to make systems more proactive, efficient, and user-friendly. Whether you're enhancing an ASP.NET Core product or modernizing a legacy stack, we help you layer in intelligence that improves decisions, automates repetitive work, and surfaces the right insights—securely and at scale.",

    items: [
      "AI strategy & use-case discovery for .NET products",
      "Predictive analytics, forecasting, and decision intelligence",
      "AI-assisted modernization for legacy .NET Framework systems",
      "Workflow automation with AI copilots and internal assistants",
      "Risk scoring, anomaly detection, and security monitoring",
      "Optimization engines for smarter routing, prioritization, and automated decisions",
    ],
  },

  whyChoose: {
    heading:
      "Why Teams Choose Quokka Labs for Enterprise-Ready .NET Development",

    subtext:
      "Shipping on .NET isn't just about writing C# and spinning up APIs. You need engineering that's intentional about performance, security, cloud readiness, and the realities of enterprise integration. As a dot net development company, Quokka Labs works like a product partner, designing architecture that lasts, delivering with discipline, and keeping your platform stable as usage, data, and teams grow.",

    items: [
      {
        number: "01",
        title: "Product-First .NET Delivery",
        desc: "We start with outcomes, not output. That means validating your primary workflows, aligning features to adoption and ROI, and designing the platform around what users actually need to accomplish—so you don't overbuild or miss the real value.",
      },
      {
        number: "02",
        title: "Transparent Execution, Predictable Releases",
        desc: ".NET platforms can hide complexity in integrations, permissions, and legacy dependencies. We keep delivery predictable with clear milestones, sprint demos, shared tracking, and early risk surfacing—so stakeholders always know what's shipping and what decisions are being made.",
      },
      {
        number: "03",
        title: "Performance & Scalability Built into the Foundation",
        desc: "We design .NET systems to stay fast under real traffic—efficient data access, caching, async processing, background jobs, and load-tested APIs. The result is consistent performance as workflows expand and concurrency increases.",
      },
      {
        number: "04",
        title: "Automation That Solves Real Bottlenecks",
        desc: "We apply automation (including AI where it fits) to remove operational friction—approvals, routing, support workflows, reporting, and repetitive internal processes—only when it's tied to measurable improvements, not buzzwords.",
      },
      {
        number: "05",
        title: "Partner-Level Communication",
        desc: "You get a team that integrates cleanly with yours: dedicated delivery leadership, clear updates, and engineers who communicate directly. Decisions don't get lost, and progress doesn't get buried behind layers.",
      },
      {
        number: "06",
        title: "Enterprise-Ready by Design",
        desc: "From SSO and audit trails to ERP/CRM integrations and compliance expectations, we build for enterprise constraints upfront. Our approach supports modernization, security hardening, and continuous evolution—without forcing risky rewrites later.",
      },
    ],
  },

  hireCTATeamBanner: {
    heading: "Hire Top Notch Developers Around You!",

    subtext:
      "Engaging with our engineers accelerates your roadmap and strengthens compliance.",

    buttonText: "Hire Developer",
    link: "https://quokkalabs.com/contact-us",
  },

  nextGenTech: {
    heading: "Future-Ready Technologies That Elevate Your Java Applications",

    subtext:
      "We future-proof your Java systems by layering in modern capabilities that improve speed, resilience, and adaptability. Our teams design these upgrades to work in real enterprise environments—where security, integrations, and uptime matter—so your application can evolve without constant rework or risky rewrites.",

    items: [
      {
        title: "Cloud",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/cloud-new-new.webp",
        desc: "We modernize Java deployments for cloud scale—standardizing environments, improving release reliability, and designing for elasticity. Whether you're moving to containers or optimizing existing cloud infrastructure, we focus on predictable performance, safer rollouts, and lower operational friction.",
      },
      {
        title: "Blockchain",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/block-chain-new.webp",
        desc: "For workflows that require strong trust signals, we add blockchain-backed components that strengthen verification and traceability. This is useful for multi-party processes, audit-heavy operations, and systems where data integrity must be provable over time.",
      },
      {
        title: "IoT",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/iot-new-new.webp",
        desc: "We build Java-based pipelines that ingest device and sensor data, normalize it, and surface it through dashboards and alerts. The result is reliable real-time visibility—plus automated actions when thresholds, faults, or anomalies are detected in the field.",
      },
      {
        title: "Data Science & Analytics",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/data-engi-new.webp",
        desc: "We create analytics layers that help teams understand what's happening inside the product and across operations. From KPI dashboards to forecasting models, we integrate decision intelligence directly into the platform so teams can act faster with better data.",
      },
      {
        title: "Robotic Process Automation (RPA)",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/automation-new.webp",
        desc: "We reduce repetitive operational effort by connecting RPA tools to Java APIs and workflows. This helps automate routine tasks like reconciliations, report generation, approvals, and data synchronization—without disrupting core systems.",
      },
      {
        title: "Generative AI",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/gen-ai-new.webp",
        desc: "We add practical GenAI features that improve productivity and reduce support workload—such as searchable knowledge assistants, documentation generation, content workflows, and internal copilots—implemented with access controls and governance for enterprise use.",
      },
      {
        title: "Machine Learning (ML)",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ml-ne.webp",
        desc: "We operationalize ML in Java ecosystems by deploying models that support personalization, prediction, classification, and anomaly detection. These models plug into your services safely—so intelligence improves outcomes without creating instability.",
      },
      {
        title: "Agentic AI",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/agentic-ai-new.webp",
        desc: "We build agentic layers that can take action across systems—coordinating tasks, following multi-step processes, escalating exceptions, and updating records automatically. This turns complex workflows into guided, self-operating processes with human oversight where needed.",
      },
    ],
  },

  blogs: {
    heading: "What's New in Dot Net Development",
  },

  faqs: {
    heading: "FAQs: Dot Net Development Services",

    items: [
      {
        question:
          "What do dot net development services typically include end-to-end?",
        answer:
          "Dot net development services usually cover the full lifecycle—from strategy and architecture to build, testing, release, and long-term support—so your product doesn't stall after launch. In practical terms, you should expect a partner to handle both engineering and 'production reality' (security, performance, observability, and integrations).",
        points: [
          "Discovery: scope, user roles, core workflows, non-functional requirements",
          "Architecture: APIs, data model, security baseline, cloud approach",
          "Engineering: backend, frontend, integrations, background jobs, admin tools",
          "QA: automated testing, regression coverage, performance validation",
          "DevOps: CI/CD pipelines, monitoring, alerting, release discipline",
          "Support: upgrades, security patches, scaling, and ongoing improvements",
        ],
      },
      {
        question:
          "What's the difference between net software development services and net application development services?",
        answer:
          "Net software development services is a broader umbrella that can include platforms, APIs, internal tools, automation scripts, and infrastructure-focused work—not just a single app. Net application development services are typically more product-specific, focusing on building or modernizing an application experience (web, mobile, desktop) with user flows, permissions, dashboards, and integrations.",
        points: [
          "Choose 'application development' when the user experience + workflows are the core deliverable",
          "Choose 'software development' when you also need platform engineering, integrations, automation, data layers, or internal tooling",
        ],
      },
      {
        question:
          "Why do businesses choose a dot net development company for modern enterprise platforms?",
        answer:
          "A strong dot net development company helps businesses ship secure, scalable systems faster—especially when teams already rely on Microsoft ecosystems (Azure, Entra ID/SSO, SQL Server, Power Platform, or enterprise governance). .NET also performs well for API-heavy, workflow-driven platforms where reliability matters more than 'quick prototypes.'",
        points: [
          "Enterprise security alignment (SSO, RBAC/ABAC, audit logging)",
          "Long-term maintainability (clean patterns, strong tooling, stable releases)",
          "Integration readiness (ERP/CRM/payment/data systems)",
          "Cloud flexibility (Azure-first or hybrid deployment models)",
        ],
      },
      {
        question:
          "Can you build cloud-based .NET solutions for Azure or hybrid environments?",
        answer:
          "Yes, modern net software development company often involve cloud-first architecture, especially for SaaS, multi-tenant platforms, and integration-heavy systems. The key is designing components that can scale independently, stay observable in production, and remain cost-efficient as usage grows.",
        points: [
          "Containerized APIs (or serverless components where appropriate)",
          "CI/CD, environment parity, and secure configuration management",
          "Centralized logging, metrics, tracing, and alerting",
          "Data strategy for performance (caching, read models, background processing)",
          "Cost controls (autoscaling rules, resource governance, performance tuning)",
        ],
      },
      {
        question: "Should my .NET APIs use REST or gRPC and how do you decide?",
        answer:
          "For most customer-facing and partner integrations, REST remains the default because it's widely compatible and easier to debug. gRPC can be a better fit for internal service-to-service communication where performance, strict contracts, and streaming are valuable.",
        points: [
          "REST: public APIs, third-party integrations, simpler client needs",
          "gRPC: internal microservices, high-throughput calls, low-latency needs",
          "Hybrid: gRPC internally + REST externally (common for scaling platforms)",
        ],
      },
      {
        question:
          "Do you support GraphQL for .NET applications, and when is it worth using?",
        answer:
          "Yes—GraphQL can be worth it when multiple clients (web, mobile, admin) need flexible data fetching, or when your frontend teams are bottlenecked by 'too many endpoints.' That said, it's not always the right default for smaller systems.",
        points: [
          "GraphQL fits: complex dashboards with many data blocks",
          "GraphQL fits: faster UI iteration without constant backend endpoint changes",
          "GraphQL fits: strong schema-based contracts across teams",
          "REST better: simple and stable API surface",
          "REST better: when you prioritize caching and standard HTTP patterns",
        ],
      },
      {
        question:
          "How do you approach microservices vs modular monolith in .NET builds?",
        answer:
          "The best architecture depends on scale, team maturity, compliance needs, and release velocity. Many successful .NET platforms start as a modular monolith (clear boundaries, strong conventions), then extract services only when real bottlenecks appear (deployment independence, scaling needs, domain separation).",
        points: [
          "Modular monolith for faster early delivery and simpler ops",
          "Microservices when independent scaling/deployments are truly needed",
          "Event-driven patterns when workflows must stay traceable and resilient",
        ],
      },
      {
        question: "What does a mature CI/CD setup look like for .NET teams?",
        answer:
          "A mature pipeline makes releases routine, not stressful. It standardizes build steps, automates testing, enforces security checks, and provides rollback paths, so teams can ship faster with fewer incidents.",
        points: [
          "Automated builds + test gates (unit, integration, smoke tests)",
          "Infrastructure-as-code and environment parity",
          "Secrets management + dependency scanning",
          "Blue/green or canary releases (where risk is high)",
          "Monitoring/alerts tied to deployment events",
          "Clear rollback and incident response playbooks",
        ],
      },
      {
        question:
          "What 'must-have' features should I plan for in a custom .NET enterprise web app?",
        answer:
          "Beyond core functionality, enterprise applications need controls for security, operations, and change management—because that's what keeps the product stable as teams and users scale.",
        points: [
          "Authentication + SSO, role-based permissions, audit trails",
          "Admin controls, feature flags, and configuration management",
          "Notifications, approvals, and workflow traceability",
          "Reporting dashboards + analytics instrumentation",
          "Data export/import, validation, and error handling",
          "Observability (logs, metrics, tracing) from day one",
        ],
      },
      {
        question:
          "Can you add AI/automation to .NET platforms without creating security and compliance risk?",
        answer:
          "Yes, when AI is implemented with strong governance, clear data boundaries, and monitored behavior. The biggest mistakes happen when teams ship AI features without deciding what data is allowed, how outputs are validated, and how failures are handled.",
        points: [
          "Limit data exposure (least privilege + redaction rules)",
          "Add human-in-the-loop paths for high-risk actions",
          "Log prompts/outputs for traceability (where appropriate)",
          "Monitor drift, latency, and failure modes",
          "Use policy controls for regulated workflows (PII, finance, healthcare)",
        ],
      },
    ],
  },
};
